export default "__VITE_ASSET__DeFLgAW6__"